/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getExportTemplate = (params) => makeApiCall(`/cnc/export`, 'GET', params);

export const getMonthlyAdminTagged = (params) =>
  makeApiCall(`/cnc/monthly-admin-tagged-account`, 'GET', params);

export const postImportMonthlyAdminTagged = (params) =>
  makeApiCall(`/cnc/import`, 'POST', params, true);
